import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';

function Header() {
  return (
    <header className="hero-header">
      <div className="header-content">
        <h1>Welcome to <span className="highlight">Nomondoru's Tech Blogs</span></h1>
        <p className="tagline">Your destination for cutting-edge tech insights and programming wisdom</p>
        <div className="cta-buttons">
          <Link to="/articles" className="btn btn-primary"><i className="fas fa-book-open"></i> Explore Articles</Link>
        </div>
      </div>
      <div className="header-image">
        <img src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80" alt="Coding on a laptop" />
        <div className="floating-badge">
          <i className="fas fa-code"></i> Tech Blog
        </div>
      </div>
    </header>
  );
}

export default Header;
